/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * One value of a breakdown dimension with its billed token usage over the range
 */
export type TumDetailsBreakdownRow = {
  /**
   * Daily tokens aligned to the result's points buckets
   */
  series: Array<number>;
  /**
   * Billed tokens for this value over the range
   */
  totalTokens: number;
  /**
   * The dimension value; empty for rows recorded before the dimension existed
   */
  value: string;
};

/** @internal */
export const TumDetailsBreakdownRow$inboundSchema: z.ZodMiniType<
  TumDetailsBreakdownRow,
  unknown
> = z.pipe(
  z.object({
    series: z.array(z.int()),
    total_tokens: z.int(),
    value: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "total_tokens": "totalTokens",
    });
  }),
);

export function tumDetailsBreakdownRowFromJSON(
  jsonString: string,
): SafeParseResult<TumDetailsBreakdownRow, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TumDetailsBreakdownRow$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TumDetailsBreakdownRow' from JSON`,
  );
}
